module.exports = __webpack_public_path__ + "media/advantage/dealerBackground-c674a988.jpg";